export default (): [Ref<boolean>, () => void] => {
  const toggleValue = ref(false);

  const toggle = (): void => {
    toggleValue.value = !toggleValue.value;
  };

  return [toggleValue, toggle];
};
